import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=073df440&"
import script from "./richText.vue?vue&type=script&lang=js&"
export * from "./richText.vue?vue&type=script&lang=js&"
import style0 from "./richText.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports